import type { RefObject } from "react";
import { useEffect } from "react";

export const useOutsideClickDetection = (ref: RefObject<HTMLDivElement | null>, callback: () => void) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (event.target && !ref.current?.contains(event.target as Node)) {
        callback();
      }
    };
    document.addEventListener("click", handleClickOutside, { capture: true });
    return () => {
      document.removeEventListener("click", handleClickOutside, {
        capture: true,
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
